import React, { useEffect, useRef } from "react";
import { Box } from "@mui/material";
import FicheContact from "./FicheContact.js";
import { logDev } from "../utils/logger.js";

const ContactCardsView = ({ contacts, isAdmin, handleDelete, handleUpdate, sondageVerrouille }) => {
  const containerRef = useRef();
  
  // 📝 Log au montage/rendu
  logDev("[ContactCardsView] rendu", { nbContacts: contacts.length, isAdmin });
  
  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollLeft = 0; // ✅ force le scroll au début
    }
  }, [contacts.length]); // ou juste [] si tu veux le faire une fois
  

  return (
    <Box
      ref={containerRef}
      sx={{
        mt: { xs: 0.5, md: 1.5 }, 
        mb: { xs: 3, md: 6 }, 
        display: { xs: "flex", md: "grid" },
        
        // 📱 Mobile : collé / 🖥️ Desktop : un peu d’air
        /*gap: { xs: 0.3, md: 1.2 },  */
        columnGap: { xs: 0.3, md: 1.2 },  // espace horizontal (inchangé)
        rowGap: { xs: 0.3, md: 0.4 },     // espace vertical (réduit)


        // 🖥️ Desktop : grid avec 2 lignes fixes
        gridTemplateRows: { md: "repeat(2, auto)" },   // 🔥 2 lignes fixes
        gridAutoFlow: { md: "column" },                // 🔥 colonnes infinies
        gridAutoColumns: { md: "240px" },              // 🔥 largeur des cartes


        // 📱 Mobile : scroll horizontal / 🖥️ Desktop : scroll si besoin
        overflowX: "auto",
        overflowY: "hidden",
        
        // 📱 Mobile : snap / 🖥️ Desktop : pas de snap
        scrollSnapType: { xs: "x mandatory", md: "none" },

        width: "100%",
        maxWidth: "100vw", 

        "& > .fiche-card": {
          width: { xs: "60vw", md: "240px" },
          maxWidth: { xs: "60vw", md: "240px" },
          flex: "0 0 auto"
        }
      }}
    >
      {contacts.map((contact) => {
         logDev("[ContactCardsView] affichage contact", contact);

         return (
        <Box
          key={contact._id}
          className="fiche-card"
          sx={{
            wordBreak: "break-all", // ou "break-word"
            whiteSpace: "normal",
            display: "flex",
            justifyContent: contacts.length === 1 ? "center" : "flex-start",
            gap: 0.5,
            p: { xs: 0.5, md: 1 }, 
          }}
        >
          <FicheContact
            contact={contact}
            onDelete={handleDelete}
            isAdmin={isAdmin}
            onUpdate={handleUpdate}
            sondageVerrouille={sondageVerrouille}
          />
        </Box>
      );
    })}
    </Box>
  );
};

export default ContactCardsView;
